"use client";

import { useHelperContext } from "@/contexts/helperContext";
import { LoaderCircleIcon } from "lucide-react";
import React from "react";

type Props = { loading?: boolean };

function Loader({ loading }: Props) {
	const { isLoading } = useHelperContext();

	if (!isLoading && !loading) return null;

	return (
		<div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[9999]">
			<LoaderCircleIcon className="w-12 h-12 text-white animate-spin" />
		</div>
	);
}

export default Loader;
